import React from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";

const UnAuthorized = () => {
  const navigate = useNavigate();

  const navigatpage = async (navname) => {
    navigate(navname);
  };

  return (
    <div className="page-body">
      {" "}
      <div className="page-wrapper">
        <div className="error-wrapper">
          <div className="container">
            <img className="img-100" src="/assets/images/sad.png" alt="" />
            <div className="error-heading">
              <h2 className="headline font-warning">401</h2>
            </div>
            <div className="col-md-8 offset-md-2">
              <h1>{strings.unAuthorized}</h1>
            </div>
            <div>
              <a
                className="btn btn-warning-gradien btn-lg"
                onClick={() => navigate("/")}
              >
                {strings.backHomePage}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UnAuthorized;
